import * as React from "react";
import { merge, $ } from "glamor";
import Tooltip from "material-ui/internal/Tooltip";

const AVATAR_SIZE = 40;
const BORDER_WIDTH = 2;
const CIRCLE_DIAMETER = AVATAR_SIZE - BORDER_WIDTH * 2;

interface IProps {
    src?: string;
    label: string;
    color: string;
    name: string;
    borderColor?: string;
}

export class Avatar extends React.PureComponent<IProps, any> {
    state = {
        showTooltip: false,
    };

    private styles = merge(
        {
            display: "block",
            height: AVATAR_SIZE,
            width: AVATAR_SIZE,
            position: "relative",
            margin: "0 -8px 0 0",
            verticalAlign: "top",
        },
        $(" svg", {
            position: "absolute",
            top: "0px",
            left: "0px",
            zIndex: 2,
            height: AVATAR_SIZE,
            width: AVATAR_SIZE,
        }),
        $(" svg .backgroundCircle", {
            fill: "white",
        }),
        $(" svg .avatarCircle", {
            strokeWidth: BORDER_WIDTH,
        }),
        $(" svg text", {
            fill: "#fff",
            dominantBaseline: "central",
            fontSize: "14px",
        }),
        $(" .image", {
            position: "absolute",
            top: "5px",
            left: "5px",
            zIndex: 3,
            height: CIRCLE_DIAMETER - 6,
            width: CIRCLE_DIAMETER - 6,
            backgroundSize: "cover !important",
            borderRadius: "50%",
        })
    );

    render() {
        const { src, label, color, name } = this.props;
        const radius = CIRCLE_DIAMETER / 2 + 1; // not sure why the + 1 but it works
        return (
            <div {...this.styles} className="avatar" onMouseEnter={this.handleEnter} onMouseLeave={this.handleLeave}>
                <svg viewBox={`0 0 ${AVATAR_SIZE} ${AVATAR_SIZE}`}>
                    <circle className="backgroundCircle" cx={AVATAR_SIZE / 2} cy={AVATAR_SIZE / 2} r={radius} />
                    <circle
                        className="avatarCircle"
                        cx={AVATAR_SIZE / 2}
                        cy={AVATAR_SIZE / 2}
                        r={radius - 3}
                        fill={color}
                        stroke={color}
                    />
                    <text x="50%" y="50%" textAnchor="middle">
                        {label}
                    </text>
                </svg>
                {src && (
                    <div
                        className="image"
                        style={{
                            background: `url("${src}") no-repeat center center`,
                        }}
                    />
                )}
                <Tooltip
                    label={name}
                    show={this.state.showTooltip}
                    horizontalPosition="center"
                    verticalPosition="bottom"
                />
            </div>
        );
    }

    private handleEnter = () => {
        this.setState({ showTooltip: true });
    };

    private handleLeave = () => {
        this.setState({ showTooltip: false });
    };
}
